import { render, staticRenderFns } from "./BiasAlterapay.vue?vue&type=template&id=2860387a&scoped=true&"
import script from "./BiasAlterapay.vue?vue&type=script&lang=js&"
export * from "./BiasAlterapay.vue?vue&type=script&lang=js&"
import style0 from "./BiasAlterapay.vue?vue&type=style&index=0&id=2860387a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860387a",
  null
  
)

export default component.exports